import { createApp } from 'vue'
import App from './App.vue'
// tailwind css
import './assets/styles/tailwind.css'
// router
import { router } from './router'

const app = createApp(App)

app.use(router);

router.isReady().then(() => {
    app.mount('#app')
})